import React from 'react';
import Icon from '../../../components/AppIcon';

const PatientMetricsCard = ({ title, value, unit, change, changeType, threshold, icon, color = "var(--color-primary)" }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-destructive';
    return 'text-text-secondary';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const isAboveThreshold = threshold && parseFloat(value) >= threshold;

  return (
    <div className="bg-card border border-border rounded-lg p-6 medical-shadow-sm">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg" style={{ backgroundColor: `${color}20` }}>
            <Icon name={icon} size={20} color={color} />
          </div>
          <div>
            <h3 className="text-sm font-medium text-text-secondary">{title}</h3>
            {threshold && (
              <div className="flex items-center space-x-1 mt-1">
                <Icon 
                  name={isAboveThreshold ? "CheckCircle" : "AlertCircle"} 
                  size={12} 
                  color={isAboveThreshold ? "var(--color-success)" : "var(--color-warning)"} 
                />
                <span className="text-xs text-text-secondary">
                  Target: {threshold}{unit}
                </span>
              </div>
            )}
          </div>
        </div>
        {change && (
          <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={16} />
            <span className="text-sm font-medium">{change}</span>
          </div>
        )}
      </div>
      <div className="flex items-baseline space-x-2">
        <span className="text-3xl font-bold text-text-primary">{value}</span>
        <span className="text-sm text-text-secondary">{unit}</span>
      </div>
      {/* Mini sparkline visualization */}
      <div className="mt-4 h-8 flex items-end space-x-1">
        {[65, 72, 68, 75, 82, 78, 85, 88, 92, 89, 94, parseFloat(value)]?.map((val, index) => (
          <div
            key={index}
            className="flex-1 rounded-sm opacity-60"
            style={{
              height: `${(val / 100) * 32}px`,
              backgroundColor: color,
              opacity: index === 11 ? 1 : 0.4
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default PatientMetricsCard;